import state, { resetSystemState } from './state'
import { MetaState, ReturnModelPayload } from './types'

/**
 * `_`-prefixed to mark them internal to the module: everything outside goes through
 * `systemService`. Matches AuthorBase's convention.
 */

export function _resetState () {
  Object.assign(state(), { ...resetSystemState() })
}

export function _setReturnModel (payload: ReturnModelPayload) {
  const s = state()

  s.returnCrudModel = payload.crudModel
  s.returnLocation = payload.from
  /**
   * Coerced to '' where Vuex left them undefined. The only readers test these through
   * `validStr()`, which treats both the same, so behaviour is unchanged and the state stays
   * typed as `string`.
   */
  s.returnLabel = payload.returnLabel ?? ''
  s.completeLabel = payload.completeLabel ?? ''
  s.attachModelId = payload.attachModelId
}

export function _clearReturnLocation () {
  const s = state()

  s.returnLocation = ''
  s.returnLabel = ''
  s.completeLabel = ''
  s.returnCrudModel = void 0
  s.attachModelId = void 0
}

export function _setMeta (payload: Partial<MetaState>) {
  /**
   * Whole-object replacement, as the Vuex mutation did. Under Vue 2 this is also what keeps
   * any key not present in `defaultState()` reactive, since the replacement object is
   * observed on assignment.
   */
  state().meta = {
    ...state().meta,
    ...payload
  }
}
